/* eslint-disable react/no-did-update-set-state */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar,
  faCheck,
  faTimes,
  faCircleQuestion,
} from '@fortawesome/pro-solid-svg-icons';

function ANPIcon({ anp }) {
  if (anp === true) {
    return (
      <FontAwesomeIcon
        size="lg"
        icon={faCheck}
        color="var(--bs-success)"
        title="This doctor is accepting new patients"
      />
    );
  } if (anp === false) {
    return (
      <FontAwesomeIcon
        size="lg"
        icon={faTimes}
        color="var(--bs-danger)"
        title="This doctor is NOT accepting new patients"
      />
    );
  }
  return (
    <FontAwesomeIcon
      size="lg"
      icon={faCircleQuestion}
      color="var(--bs-secondary)"
      title="Our data provider does not have ANP data for this doctor"
    />
  );
}

function DoctorRow({
  doctor = {},
  checkNetwork = true,
  showStar = false,
}) {
  const dispatch = useDispatch();
  const {
    quote: {
      cpsID: planCPS,
      carrier,
    },
    doctors: {
      selectedDoctor: {
        name: docName,
        address: docAddress,
      },
    },
    theme: {
      hidePCPwithNullID,
      ignorePCPIDCarriers = [],
    },
  } = useSelector(store => store);
  const [ checked, setChecked ] = useState(false);

  useEffect(() => {
    if (doctor.name !== docName || doctor.address !== docAddress) {
      setChecked(false);
    }
  }, [docName, docAddress]);

  function handleClick() {
    if (checked) {
      dispatch({ type: 'CLEAR_SELECTED_DOCTOR' });
      setChecked(false);
    } else {
      setChecked(true);
      dispatch({ type: 'SET_SELECTED_DOCTOR', doctor });
    }
  }

  const oon = !(doctor.coveredPlans.includes(planCPS)); // out of network

  // some carriers like Clover do not require any pcp identifier. If a carrier
  // is in the ignorePCPIDCarriers list then we don't need to disable docs
  // who vericred does not supply a pcp_id for.
  const checkForPCPID = !(ignorePCPIDCarriers.includes(carrier));

  let bgColor;
  let disabled = false;

  if ((checkNetwork && oon) || (checkForPCPID && !doctor.pcpID)) {
    bgColor = 'var(--bs-gray-300)';
    disabled = true;
  } else if (checked) {
    bgColor = 'var(--bs-primaryFocusBg)';
  }

  if (hidePCPwithNullID) {
    if (carrier.toLowerCase() === 'aetna') {
      if (!doctor.pcpID || !doctor.externalID) { return null; }
    } else if (carrier.toLowerCase() === 'humana') {
      if (!doctor.pcpID) { return null; }
    } else if (carrier.toLowerCase() === 'cigna') {
      if (!doctor.pcpID) { return null; }
    } else if (carrier.toLowerCase() === 'unitedhealthcare') {
      if (!doctor.pcpID) { return null; }
    }
  }

  const anp = doctor.acceptingNewPatients;

  return (
    <tr
      role={disabled ? '' : 'button'}
      onClick={() => {
        if (!disabled) {
          handleClick();
        }
      }}
      id={`${doctor.name}${doctor.address}`}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <td>
        <input
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={handleClick}
        />
      </td>
      <td>
        {doctor.name}
      </td>
      <td>
        {doctor.specialties.join(', ')}
      </td>
      <td>
        <ANPIcon anp={anp} />
      </td>
      <td>
        {doctor.address}
        {doctor.address2 && ` ${doctor.address2}`}
        {', '}
        {doctor.city}
        {', '}
        {doctor.state}
        {doctor.zipcode}
      </td>
      {showStar && (
        <td>
          {doctor.important ? (
            <FontAwesomeIcon
              size="lg"
              icon={faStar}
              color="#FFBA00"
            />
          ) : null}
        </td>
      )}
    </tr>
  );
}

export default DoctorRow;
